import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DocumentTemplate, DocumentTemplateApiCallerService, DocumentTemplateVariable } from '../services/document-template-api-caller.service';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { ConfigTemplateComponent } from '../config-template/config-template.component';
import { environment } from 'src/environments/enviroments';
import Swal from 'sweetalert2';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-edit-template-modal',
  templateUrl: './edit-template-modal.component.html',
  styleUrls: ['./edit-template-modal.component.scss']
})

export class EditTemplateModalComponent implements AfterViewInit {
  public loadingSaveDocument = false;
  private timerInterval: any;
  public isTimerRunning: boolean = false;
  public dateAutoSave: Date;
  public title: string = "";
  public isNewDocument: boolean;
  public apiKeyTiny = environment.apiKeyTinyEditor;
  public apiKeyTinyDev = "devApikey";
  public templateVariables: DocumentTemplateVariable[];
  public selectableTemplateVariables$: BehaviorSubject<DocumentTemplateVariable[]>;
  public isAutoSaveSuccess: boolean = true;

  @ViewChild('editor', { static: false }) editor: EditorComponent;
  private generateVariablesToSelectInEditor(variables: DocumentTemplateVariable[]): {text: string, value: string}[] {
    const newVariables = variables.map(v => {
      const baseValue  = v.isIterable ?  `{{#each ${v.name.replace(/{{|}}/g, "")}}} {{/each}}` : `${v.name}`;
      const valueToInsert = v.description.includes('Firma') 
      ? `<div style="margin-bottom: 55px;">${baseValue}</div>` 
      : baseValue;
      return ({
        text  : v.description,
        value: valueToInsert
      });
    });
    newVariables.push({text: 'Salto de Pagina', value: '<div style="page-break-after:always">{{SaltoPagina}}</div>'});
    newVariables.push({text: 'Logo INGE', value: '<img src="https://ingeappdvstorage.blob.core.windows.net/tempdocuments/Logos/Icon.png?sv=2023-01-03&st=2025-02-20T13%3A54%3A06Z&se=2030-02-21T13%3A54%3A00Z&sr=b&sp=r&sig=bDo6CPNMNT59wS4BZlIcaE2VqXRlFw9TWn5FN6ylvPU%3D" height="60" />'});
    newVariables.push({text: 'Footer INGE', value: '<div style="width: 100%;"><img src="https://ingeappdvstorage.blob.core.windows.net/tempdocuments/Logos/footer.png?sv=2023-01-03&st=2025-02-20T14%3A46%3A51Z&se=2029-02-21T14%3A46%3A00Z&sr=b&sp=r&sig=YpFIRAwzOlsn%2BmKkO5EfJx2grHgoDs0AY6GHauMa800%3D" style="width: 100%; height: auto; max-width: 100%;" /></div>'});
    return newVariables;
  }

  init: EditorComponent['init'] = {
    selector: '*',  
    min_height: 880,
    width: 940,
    resize: 'both',
    placeholder: '...',
    paste_data_images: true,
    plugins: 'lists link image table code help wordcount',
    toolbar: 'undo redo | styles | bold italic underline | alignleft aligncenter alignright alignjustify | bullist numlist | link image table | code wordcount | help',
    content_style: 'body { font-family:Arial, sans-serif; font-size:14px } @page { margin-left: 0; margin-right: 0; margin-bootom: 0; margin-top: 0; }',
    table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
    valid_elements: '*[*]',
    contextmenu: 'insertVariable', 
      setup: (editor) => {
        editor.on('init', () => console.log('Editor inicializado'));
        editor.on('change', () => console.log('Contenido modificado'));
        editor.ui.registry.addAutocompleter('variable',{
          trigger: '{{',
          minChars: 1,
          columns: 1,
          fetch: (pattern: any) => {
            return new Promise((resolve) => {
              const selectableVariables = this.generateVariablesToSelectInEditor(this.selectableTemplateVariables$.value);
              const filteredVariables = selectableVariables.filter(v => v.text.toLowerCase().includes(pattern.toLowerCase()));
              resolve(filteredVariables);
            });
          },
          onAction: (autocompleteApi: any, rng: any, value: any) => {
            editor.selection.setRng(rng);
            editor.insertContent(value);
            autocompleteApi.hide();
          }
        }),
        editor.ui.registry.addContextMenu('insertVariable', {
          update: () => [
            {
              text: 'Insertar Variable',
              onAction: () => {
                const selectableVariables = this.generateVariablesToSelectInEditor(this.selectableTemplateVariables$.value);
                editor.windowManager.open({
                  title: 'Seleccionar Variable',  
                  body: {
                    type: 'panel',
                    items: [
                      {
                        type: 'listbox',  
                        name: 'variablesList',
                        items: selectableVariables,
                      },
                    ]
                  },
                  buttons: [
                    {
                      type: 'cancel',
                      text: 'Cancelar'
                    },
                    {
                      type: 'submit',
                      text: 'Insertar',
                      primary: true,
                    }
                  ],
                  onSubmit: (api) => {
                    const data = api.getData();
                    const variableSeleccionada = data['variablesList'];
                    editor.insertContent(`${variableSeleccionada}`);
                    api.close(); 
                  } 
                });
              }
            }
          ]
        });
    }
  };
  
  constructor(public dialogRef: MatDialogRef<EditTemplateModalComponent>, @Inject(MAT_DIALOG_DATA) public data: DocumentTemplate, public dialog: MatDialog, private documentTemplateService: DocumentTemplateApiCallerService) {
    this.selectableTemplateVariables$ = new BehaviorSubject([]);
    this.templateVariables = [];
    if(data) {
      this.title = "Editar Plantilla - " + data.name;
      this.isNewDocument = false;
      this.dateAutoSave = data.modifiedAt;
    }
    else { 
      this.title = "Nueva Plantilla", this.isNewDocument = true;
      this.data = {
        templateId: 0,
        name: '',
        description: '',
        htmlTemplate: '',
        txtTemplate: '',
        categoryName: '',
        categoryId: 0,
        createdAt: new Date(),
        modifiedAt: new Date(),
        modifiedBy: '',
        used: null,
        jsonConfig: {
          size: 0,
          orientation: 0,
        },
      };
      this.dateAutoSave = new Date();
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.editor && this.editor.editor && this.data) {
        this.loadFileEditor(this.data);
      }
    }, 910);  
  }

  ngOnInit(): void {
    this.getTemplateVariables();
    if(!this.isNewDocument) {
      // this.startTimerAutoSave();
    }
  }

  ngOnDestroy(): void {
    this.stopTimerAutoSave();
  }

  getTemplateVariables() {
    this.documentTemplateService.getTemplateVariables()
    .subscribe(res => {
      this.templateVariables = res;
      this.selectableTemplateVariables$.next(res);
    })
  }

  public loadFileEditor(template: DocumentTemplate) {
    if (this.editor && this.editor.editor && template) {
      this.editor.editor.setContent(template.htmlTemplate);
    } else {
      console.error('Editor no disponible');
    }
  }

  public onSave(): void {
    this.loadingSaveDocument = true;
    const html = this.editor.editor?.getDoc();
    const htmlString = html?.documentElement.outerHTML;
    const text = this.editor.editor?.getContent({ format: 'text' });
    this.data.htmlTemplate = htmlString;
    this.data.txtTemplate = text;
    if(this.isNewDocument) {
      this.openModalConfig(this.data);
    }
    else {
      this.saveDocument();
    }
  } 

  public openModalConfig(template: DocumentTemplate): void {
    const dialogRef = this.dialog.open(ConfigTemplateComponent, {
      maxWidth: '600px',
      height: 'auto',
      data: template,
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result) {
        this.data = result;
        this.isNewDocument = false;
        this.title = "Editar Plantilla - " + result?.name;
        this.saveDocument();
        // this.startTimerAutoSave();
      }
      else {
        this.loadingSaveDocument = false;
      }
    });
  }

  public closeEditorModal() {
    this.dialog.closeAll();
  }

  public saveDocument() {
    Swal.fire({
      title: 'Guardando...',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });    

    this.loadingSaveDocument = true;
    this.documentTemplateService.createDocumentTemplate(this.data).subscribe({
      next: (result) => {
        Swal.close();
        Swal.fire({
          icon: 'success',
          titleText: 'Plantilla Guardada',
        });
        this.data.templateId = result.value.templateId;
        console.log(result.value.templateId);
        this.loadingSaveDocument = false;
        this.isAutoSaveSuccess = true;
      },
      error: (err) => {
        Swal.close();
        Swal.fire({
          icon: 'error',
          titleText: 'Ocurrió un error al guardar la plantilla',
          text: err.error.message,
        });
        this.loadingSaveDocument = false;
      } 
    });
  }

  public saveDocumentAutoSave() {
    this.loadingSaveDocument = true;
    const html = this.editor.editor?.getDoc();
    const htmlString = html?.documentElement.outerHTML;
    const text = this.editor.editor?.getContent({ format: 'text' });
    this.data.htmlTemplate = htmlString;
    this.data.txtTemplate = text;
    this.documentTemplateService.createDocumentTemplate(this.data).subscribe({
      next: (result) => {
        console.log("Autoguardado Exitoso " + new Date())
        this.loadingSaveDocument = false;
        this.isAutoSaveSuccess = true;
      },
      error: (err) => {
        console.log(err);
        this.loadingSaveDocument = false;
        this.isAutoSaveSuccess = false;
      } 
    });
  }

  startTimerAutoSave(): void {
    this.isTimerRunning = true;
    this.timerInterval = setInterval(() => {
      this.dateAutoSave = new Date();
      this.saveDocumentAutoSave();
    }, 60000); //60 Segundos
  }

  stopTimerAutoSave(): void {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
      this.isTimerRunning = false;
    }
  }

}